import { ReactNode } from 'react'
import { clsx } from 'clsx'
import styles from './RadialBackground.module.scss'
import welcomeStyles from './WelcomeBackground.module.scss'
import mainStyles from './MainBackground.module.scss'

type Props = {
    variant: 'main' | 'welcome'
    children: ReactNode
    className?: string
}

export const RadialBackground = ({ variant, children, className }: Props) => {
    const isMain = variant === 'main'

    const rayCount = isMain ? 6 : 5

    return (
        <>
            {children}

            <div
                className={clsx(
                    styles.radialContainer,
                    { [welcomeStyles.radialContainer]: !isMain },
                    { [mainStyles.radialContainer]: isMain },
                    className
                )}
            >
                <div className={isMain ? mainStyles.radialCenter : welcomeStyles.radialCenter}>
                    {new Array(rayCount).fill(null).map((_, i) => (
                        <div
                            key={i}
                            className={clsx(styles.rayContainer, {
                                [welcomeStyles['rayContainer' + (i + 1)]]: !isMain,
                                [mainStyles['rayContainer' + (i + 1)]]: isMain,
                            })}
                        >
                            <span
                                className={clsx(
                                    styles.ray,
                                    { [welcomeStyles.ray]: !isMain },
                                    { [mainStyles.ray]: isMain }
                                )}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
